exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom_nowrap{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.cbp-item {\n    height: 226px;\n}\n.cbp-caption {\n    height: 100%;\n}\n.cbp-caption-defaultWrap{\n    height: 100%;\n}\n.cbp-caption-activeWrap{\n    height: 100%;\n}\n", ""]);

// exports
